export default "__VITE_ASSET__BgmvPywC__"